<template>
  <a-layout>
    <Breadcrumb />
    <div class="page-title-container">
      <span class="page-title">{{ modalTitle }}</span>
    </div>
    <div class="content-container" style="margin-top: 20px">
      <div class="content-panel">
        <div class="timeline-container">
          <div class="timeline-caption">
            <a-button v-if="canManageProgress && projectProgress.canRollbackEngineerProgress" @click="pickEngineerRollbackPoint" size="small" icon="reload" class="reload-btn">进度回退</a-button>
            <div :class="['caption-text', { 'caption-text__lower': !canManageProgress }]">项目进度</div>
          </div>
          <EngineerNode
              v-for="progressNode in projectProgress.engineeringProgressNodeList"
              :key="progressNode.code"
              :project-id="projectId"
              :progress-node="progressNode"
              :can-manage-progress="canManageProgress"
              :next-engineering-node-status-name="nextEngineeringNodeStatusName"
              @previewDoc="onPreviewFile"
              @downloadDoc="download"
              @makeEngineerProgress="onMakeEngineeringProgress"/>
        </div>

        <div class="dash-line"></div>

        <div class="timeline-container">
          <div class="timeline-caption">
            <a-button v-if="canManageProgress && projectProgress.canRollbackPaymentProgress" @click="pickPaymentRollbackPoint" size="small" icon="reload" class="reload-btn">进度回退</a-button>
            <div :class="['caption-text', { 'caption-text__lower': !canManageProgress }]">付款进度</div>
          </div>
          <ProgressNode
              v-for="progressNode in projectProgress.paymentProgressNodeList"
              :key="progressNode.code"
              :project-id="projectId"
              :progress-node="progressNode"
              :can-manage-progress="canManageProgress"
              :next-payment-node-status-name="nextPaymentNodeStatusName"
              @previewDoc="onPreviewFile"
              @downloadDoc="download"
              @escapePaymentProgress="onEscapePayment"
              @makePaymentProgress="onMakePaymentProgress"/>

        </div>
      </div>
    </div>

    <a-modal
        :visible="pickEngineerProgressModalShow"
        title="项目进度回退"
        @ok="onRollbackEngineerProgress"
        @cancel="pickEngineerProgressModalShow = false"
    >
      <div class="input-container">
        <span class="pwd-label">选择进度</span>
        <a-select v-model="targetEngineerProgressLogId" style="width: 300px; margin-left: 20px">
          <a-select-option v-for="progressLog in engineerProgressLogList" :key="progressLog.logId" :value="progressLog.logId">
            {{progressLog.logDate}} &nbsp;&nbsp;&nbsp; {{ progressLog.nodeName }} - {{ progressLog.nodeStatusName }}
          </a-select-option>
          <a-select-option value="0">初始状态</a-select-option>
        </a-select>
      </div>
    </a-modal>

    <a-modal
        :visible="pickPaymentProgressModalShow"
        title="付款进度回退"
        @ok="onRollbackPaymentProgress"
        @cancel="pickPaymentProgressModalShow = false"
    >
      <div class="input-container">
        <span class="pwd-label">选择进度</span>
        <a-select v-model="targetPaymentProgressLogId" style="width: 300px; margin-left: 20px">
          <a-select-option v-for="progressLog in paymentProgressLogList" :key="progressLog.logId" :value="progressLog.logId">
            {{progressLog.logDate}} &nbsp;&nbsp;&nbsp; {{ progressLog.nodeName }} - {{ progressLog.nodeStatusName }}
          </a-select-option>
          <a-select-option value="0">初始状态</a-select-option>
        </a-select>
      </div>
    </a-modal>

    <a-modal
      :visible="chooseDateModalShow"
      title="选择日期"
      @ok="onChooseProgressDate"
      @cancel="chooseDateModalShow = false"
      >
      <div class="input-container">
        <span class="pwd-label">选择日期</span>
        <a-date-picker @change="onProgressDatePicked" style="width: 300px; margin-left: 20px"></a-date-picker>
      </div>
    </a-modal>

    <DocPreview ref="docPreview" />
  </a-layout>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import {
  fetchProjectProgress,
  loadEngineerProgressLogs,
  loadPaymentProgressLogs,
  rollbackEngineerProgress,
  rollbackPaymentProgress,
  updateProjectEngineeringProgress,
  updateProjectPaymentProgress
} from "@/views/progress/ProgressApi";
import {dtFormat} from "@/components/DateUtils";
import {baseURL} from "@/services/HttpService";
import DocPreview from "@/views/DocPreview.vue";
import {fetchManageProgressPermission} from "@/services/PermissionApi";
import ProgressNode from "@/views/progress/ProgressNode.vue";
import EngineerNode from "@/views/progress/EngineerNode.vue";

export default {
  components: {EngineerNode, ProgressNode, DocPreview, Breadcrumb },
  data() {
    return {
      projectId: "",
      projectProgress: {
        projectId: "",
        projectName: "",
        paymentProgressNodeList: [],
        engineeringProgressNodeList: [],
        engineeringNodeStatus: "",
        paymentNodeStatus: "",
        canRollbackEngineerProgress: false,
        canRollbackPaymentProgress: false,
      },
      pickEngineerProgressModalShow: false,
      pickPaymentProgressModalShow: false,
      engineerProgressLogList:[],
      paymentProgressLogList:[],
      targetEngineerProgressLogId: null,
      targetPaymentProgressLogId: null,
      headers: {
        authorization: 'authorization-text',
      },
      uploadUrl: baseURL + "/upload/progress",
      viewUrl: baseURL + "/attachment?fileName=",
      progressDate: "",
      chooseDateModalShow: false,
      progressCodeType: "",
      progressCode: "",
      canManageProgress: false,
    };
  },
  computed: {
    modalTitle() {
      if(this.projectProgress.projectName === ""){
        return "进度更新";
      } else {
        return this.projectProgress.projectName + " - 进度更新";
      }
    },
    nextEngineeringNodeStatusName() {
      if (this.projectProgress.engineeringNodeStatus === "NOT_STARTED") {
        return "发起";
      } else {
        return "标记为完成";
      }
    },
    nextPaymentNodeStatusName(){
      if (this.projectProgress.paymentNodeStatus === "NOT_STARTED") {
        return "发起";
      } else {
        return "标记为完成";
      }
    }
  },
  created() {
    this.projectId = this.$route.params.id;
    this.loadProjectProgress();
    this.loadManageProgressPermission();
  },
  methods: {
    onProgressDatePicked(date, dateString){
      console.log('选择日期', dateString);
      this.progressDate = dateString;
    },
    onChooseProgressDate(){
      if(this.progressCodeType==='paymentProgressCode') {
        this.updatePaymentProgress(this.progressCode);
      } else if (this.progressCodeType === 'engineeringProgressCode') {
        this.updateEngineeringProgress(this.progressCode);
      }
      this.chooseDateModalShow = false;
    },
    onPreviewFile(doc){
      this.$refs.docPreview.previewFile(doc);
    },
    download(doc){
      if(doc.url) {
        let docUrl = doc.url;
        if(!docUrl.startsWith("http")) {
          docUrl = this.viewUrl + docUrl;
        }
        console.log("文件下载路径", docUrl);
        window.open(docUrl, '_blank');
      } else {
        this.$message.error("缺少文件路径属性，请重新上传");
      }

    },
    // 预付款和并网款环节可跳过
    canEscape(progressNode) {
      return progressNode.current && progressNode.status==='NOT_STARTED' && (progressNode.code ==='PREPAY' || progressNode.code ==='GRID_CONNECTION_PAYMENT');
    },
    onRollbackPaymentProgress(){
      if(this.targetPaymentProgressLogId === null) {
        this.$message.error("请选择回退进度点");
      } else {
        rollbackPaymentProgress(this.targetPaymentProgressLogId, this.projectId).then(response => {
          if (response.data.code === "SUCCESS") {
            this.$message.success("操作成功");
            this.loadProjectProgress();
            this.pickPaymentProgressModalShow = false;
          } else {
            this.$message.error("操作失败");
          }
        });
      }
    },
    onRollbackEngineerProgress(){
      if(this.targetEngineerProgressLogId === null) {
        this.$message.error("请选择回退进度点");
      } else {
        rollbackEngineerProgress(this.targetEngineerProgressLogId, this.projectId).then(response => {
          if (response.data.code === "SUCCESS") {
            this.$message.success("操作成功");
            this.loadProjectProgress();
            this.pickEngineerProgressModalShow = false;
          } else {
            this.$message.error("操作失败");
          }
        });
      }
    },
    pickEngineerRollbackPoint(){
      this.targetEngineerProgressLogId = null;
      loadEngineerProgressLogs(this.projectId).then(response => {
        if (response.data.code === "SUCCESS") {
          let logList = response.data.data;
          if(logList && logList.length > 0) {
            for(let i=0; i<logList.length; i++){
              let log = logList[i];
              log.logDate = dtFormat(log.logTime);
            }
          }
          this.engineerProgressLogList = logList;
          this.pickEngineerProgressModalShow = true;
        } else {
          this.$message.error("读取数据失败");
        }
      });
    },
    pickPaymentRollbackPoint(){
      this.targetPaymentProgressLogId = null;
      loadPaymentProgressLogs(this.projectId).then(response => {
        if (response.data.code === "SUCCESS") {
          let logList = response.data.data;
          if(logList && logList.length > 0) {
            for(let i=0; i<logList.length; i++){
              let log = logList[i];
              log.logDate = dtFormat(log.logTime);
            }
          }
          this.paymentProgressLogList = logList;
          this.pickPaymentProgressModalShow = true;
        } else {
          this.$message.error("读取数据失败");
        }
      });
    },
    findNodeStatusImg(progressNodeStatus) {
      if (progressNodeStatus === "NOT_STARTED") {
        return require("@/assets/icon-not-start.png");
      } else if (progressNodeStatus === "INITIATED") {
        return require("@/assets/icon-started.png");
      } else if (progressNodeStatus === "COMPLETED") {
        return require("@/assets/icon-completed.png");
      } else if (progressNodeStatus === "SKIPPED") {
        return require("@/assets/icon-skipped.png");
      } else {
        return require("@/assets/icon-in-progress.png");
      }
    },
    loadManageProgressPermission(){
      fetchManageProgressPermission().then(response => {
        if (response.data.code === "SUCCESS") {
          this.canManageProgress = response.data.data;
        }
      });
    },
    loadProjectProgress() {
      fetchProjectProgress(this.projectId).then(response => {
        this.loading = false;
        if (response.data.code === "FAILED") {
          this.$message.error("读取数据失败");
        } else {
          let progressData = response.data.data;
          // 时间格式化
          if(progressData.engineeringProgressNodeList && progressData.engineeringProgressNodeList.length > 0){
            for(let i=0; i<progressData.engineeringProgressNodeList.length; i++){
              let progressNode = progressData.engineeringProgressNodeList[i];
              if(progressNode && progressNode.logList.length > 0) {
                for(let j=0; j<progressNode.logList.length; j++){
                  let log = progressNode.logList[j];
                  log.logTime = dtFormat(log.logTime);
                }
              }

              let docList = progressNode.docList;
              if(docList!==undefined && docList!==null && docList.length > 0) {
                for(let j=0; j < docList.length; j++){
                  let doc = docList[j];
                  doc.viewUrl = this.viewUrl + doc.url;
                  doc.status = 'done';
                  console.log('set doc url', doc.viewUrl);
                }
              }
            }
          }
          if(progressData.paymentProgressNodeList && progressData.paymentProgressNodeList.length > 0){
            for(let i=0; i<progressData.paymentProgressNodeList.length; i++){
              let progressNode = progressData.paymentProgressNodeList[i];
              if(progressNode && progressNode.logList.length > 0) {
                for(let j=0; j<progressNode.logList.length; j++){
                  let log = progressNode.logList[j];
                  log.logTime = dtFormat(log.logTime);
                }
              }
              if(progressNode.code === 'PREPAY') {
                this.prepayNode = progressNode;
              }
              if(progressNode.code === 'GRID_CONNECTION_PAYMENT') {
                this.gradeConnectionPaymentNode = progressNode;
              }
              if(progressNode.code === 'COMPLETION_PAID') {
                this.completionPaymentNode = progressNode;
              }
            }
          }

          this.projectProgress = progressData;
        }
      });
    },
    onEscapePayment(curPaymentProgressNodeCode){
      let self = this;
      this.$confirm({
        title: "确认",
        content: "确认跳过当前付款进度吗？",
        onOk: () => {
          self.skipPaymentProgress(curPaymentProgressNodeCode);
        }
      });
    },
    skipPaymentProgress(curPaymentProgressNodeCode){
      let params = {
        projectId: this.projectId,
        paymentProgress: curPaymentProgressNodeCode,
        nodeStatus: 'SKIPPED'
      }
      updateProjectPaymentProgress(params).then(response => {
        this.loading = false;
        if (response.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.loadProjectProgress();
        }
      });
    },
    onMakePaymentProgress(curPaymentProgressNodeCode) {
      this.progressCodeType = "paymentProgressCode";
      this.progressCode = curPaymentProgressNodeCode;
      this.chooseDateModalShow = true;
    },
    updatePaymentProgress(curPaymentProgressNodeCode) {
      let params = {
        projectId: this.projectId,
        paymentProgress: curPaymentProgressNodeCode,
        progressDate: this.progressDate,
        nodeStatus: this.calNextNodeStatus(this.projectProgress.paymentNodeStatus)
      }
      console.log("更新付款进度", params);
      updateProjectPaymentProgress(params).then(response => {
        this.loading = false;
        if (response.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.loadProjectProgress();
        }
      });
    },
    onMakeEngineeringProgress(curEngineeringProgressNodeCode) {
      this.progressCodeType = "engineeringProgressCode";
      this.progressCode = curEngineeringProgressNodeCode;
      this.chooseDateModalShow = true;
    },
    updateEngineeringProgress(curEngineeringProgressNodeCode) {
      let params = {
        projectId: this.projectId,
        engineeringProgress: curEngineeringProgressNodeCode,
        progressDate: this.progressDate,
        nodeStatus: this.calNextNodeStatus(this.projectProgress.engineeringNodeStatus)
      }
      console.log("更新工程进度", params);
      updateProjectEngineeringProgress(params).then(response => {
        this.loading = false;
        if (response.data.code === "SUCCESS") {
          this.$message.success("操作成功");
          this.loadProjectProgress();
        }
      });
    },
    calNextNodeStatus(curNodeStatus) {
      if (curNodeStatus === "NOT_STARTED") {
        return "INITIATED";
      } else {
        return "COMPLETED";
      }
    },

  }
};
</script>

<style scoped>
.content-panel {
  background-color: #fff;
  padding: 20px;
  min-height: 60vh;
}
.dash-line {
  border-bottom: 1px dashed #999999;
  margin: 20px 0;
}
.timeline-container {
  display: flex;
  align-items: flex-start;
  padding: 50px 0;
  overflow-x: auto;
}
.timeline-caption {
  font-size: 16px;
  font-weight: bold;
  padding-right: 30px;
  white-space: nowrap;
}
.reload-btn {
  margin-bottom: 4px;
}
.caption-text {
  text-align: center;
  padding-bottom: 24px;
}
</style>
